import script from "./EncomendaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EncomendaForm.vue?vue&type=script&setup=true&lang=js"

import "./EncomendaForm.vue?vue&type=style&index=0&id=53acfee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53acfee0"]])

export default __exports__